export default __webpack_public_path__ + "static/media/speaker.9a32c395.png";